import { useState } from 'react';

import { CollaboratorInput, Text } from 'shell/components';

const users = [
    {
        owner_account_id: '1',
        first_name: 'Georgina',
        last_name: 'Watson',
    },
    {
        owner_account_id: '2',
        first_name: 'Louisa',
        last_name: 'Kirk',
    },
];

const CollaboratorInputDemo = () => {
    const [value, setValue] = useState([]);

    return (
        <>
            <Text variant={'sh1'}>CollaboratorInput</Text>
            <CollaboratorInput id={'collaborator-input-1'} options={users} value={value} onChange={setValue} />
        </>
    );
};

export default CollaboratorInputDemo;
